var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"imgs"},_vm._l((_vm.descImageList),function(item){return _c('div',{key:item.imageId},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(item.filePath),expression:"item.filePath"}]})])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }